import React, { useEffect, useState } from 'react';
import { Ecosystem } from '../views/ecosystem/ecosystem.js';
import { IssueSelect } from '../widgets/issue-select.js';
import { OrganizationsPage } from '../views/organizations/organizations.js';
import { OrganizationDetailPage } from '../views/organization-detail/organization-detail.js';
import { GeographyPage } from '../views/geography/geography.js';
import { useOrganizationsDispatch } from '../../contexts/organization-context.js';
import { SortModal } from '../modals/sort-modal/sort-modal.js';
import { useNavigation } from '../../contexts/navigation-context.js';
import { OrganizationsComparePage } from '../views/organizations-compare/organizations-compare.js';
import { AppSidePanel } from './app-side-panel.js';
import saltExchangeLogo from '../../assets/loading.png';
import * as _ from 'lodash';
import * as cn from 'classnames';
import './app-frame.css';
import '../../data.js';

export const AppFrame = () => {
  const [ecosystemPhases, setEcosystemPhases] = useState(window.ecosystemPhases.map((er) => []));
  const [causes, setCauses] = useState([]);
  const [ecosystemRoles, setEcosystemRoles] = useState([]);
  const [ecosystemActivities, setEcosystemActivities] = useState([]);

  const [organizations, setOrganizations] = useState(window.organizations.map((o) => ({ ...o, type: 'organization' })));
  const [selectedIssue, setSelectedIssue] = useState('CSEC');
  const [isIssueSelectionOpen, setIssueSelectionOpen] = useState(false);

  const organizationDispatch = useOrganizationsDispatch();

  const { currentPage, to } = useNavigation();

  const loadData = async () => {
    fetch(process.env.REACT_APP_API_URL + '/phases').then(async (response) => {
      const responseData = await response.json();
      setEcosystemPhases(responseData.results.map((p) => ({ ...p, type: 'ecosystem-phase' })));
    });
    fetch(process.env.REACT_APP_API_URL + '/activities').then(async (response) => {
      const responseData = await response.json();
      setEcosystemActivities(responseData.results.map((q) => ({ ...q, type: 'ecosystem-activity' })));
    });
    fetch(process.env.REACT_APP_API_URL + '/causes').then(async (response) => {
      const responseData = await response.json();
      setCauses(responseData.results.map((c) => ({ ...c, type: 'cause' })));
    });
    fetch(process.env.REACT_APP_API_URL + '/roles').then(async (response) => {
      const responseData = await response.json();
      setEcosystemRoles(responseData.results.map((c) => ({ ...c, type: 'ecosystem-role' })));
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (currentPage === null) {
      to({ pageId: 'ecosystem-overview' });
      return;
    }
  }, [currentPage]);

  useEffect(() => {
    if (selectedIssue) {
      const allOrgs = window.organizations.map((o) => ({ ...o, type: 'organization' }));
      setOrganizations(allOrgs.filter((o) => o.geography.includes(selectedIssue)));
    }
  }, [selectedIssue]);

  return (
    <div className="app-frame">
      {/* <div className="app-header">
        <div className="app-header-logo-container">
          <img src={saltExchangeLogo} alt="SaltExchange" />
        </div>
      </div> */}
      <div className="toggleBar">
        <div className="app-header-logo-container">
          <img src={saltExchangeLogo} alt="SaltExchange" />
          <div className="logo-name-container">
            <div className="logo-label">SaltExchange</div>
            <div className="logo-sublabel">Ecosystem Explorer</div>
            <div className="logo-issue-select-container"></div>
          </div>
        </div>
        {/* <IssueSelect
          selectedIssue={selectedIssue}
          setSelectedIssue={setSelectedIssue}
          isIssueSelectionOpen={isIssueSelectionOpen}
          setIssueSelectionOpen={setIssueSelectionOpen}
        /> */}

        <div className="toggleContainer">
          <div
            className={cn('toggle-button', currentPage?.pageId === 'ecosystem-overview' && 'selected')}
            onClick={() => {
              organizationDispatch({ type: 'organization-selection-cleared' });
              to({ pageId: 'ecosystem-overview' });
            }}
          >
            Ecosystem
          </div>
          <div
            className={cn('toggle-button', currentPage?.pageId === 'geographic-overview' && 'selected')}
            onClick={() => {
              organizationDispatch({ type: 'organization-selection-cleared' });
              to({ pageId: 'geographic-overview' });
            }}
          >
            Geography
          </div>
          <div
            className={cn('toggle-button', (currentPage?.pageId === 'organization-search' || currentPage?.pageId === 'organization-detail') && 'selected')}
            onClick={() => {
              organizationDispatch({ type: 'organization-selection-cleared' });
              to({ pageId: 'organization-search' });
            }}
          >
            Organizations
          </div>
        </div>
      </div>
      <div className="contentContainer">
        <div className="diagramContainer">
          <div className={cn('diagram', currentPage?.pageId === 'ecosystem-overview' && 'selected')}>
            <Ecosystem ecosystemRoles={ecosystemRoles} ecosystemActivities={ecosystemActivities} />
          </div>
          <div className={cn('diagram', currentPage?.pageId === 'geographic-overview' && 'selected')}>
            <GeographyPage />
          </div>
          <div className={cn('diagram', currentPage?.pageId === 'organization-search' && 'selected')}>
            <OrganizationsPage activities={ecosystemActivities} organizations={organizations} />
          </div>
          <div className={cn('diagram', currentPage?.pageId === 'organization-detail' && 'selected')}>
            <OrganizationDetailPage />
          </div>
          <div className={cn('diagram', currentPage?.pageId === 'organizations-compare' && 'selected')}>
            <OrganizationsComparePage />
          </div>
        </div>
        <div className="paneContainer">
          <AppSidePanel
            selectedIssue={selectedIssue}
            ecosystemPhases={ecosystemPhases}
            ecosystemRoles={ecosystemRoles}
            ecosystemActivities={ecosystemActivities}
            organizations={organizations}
          />
        </div>
      </div>
      <SortModal />
    </div>
  );
};
